export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Roman-e0b83f0a0d775b94af36067d3574fd0a.eot";